import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';
import { UnitItemTakePostState } from 'common-ts/dist/models/UnitItem';
import { fetchUnitItemsList } from "./UnitItemListPostRedux";

const initialState: UnitItemTakePostState = {
    unitItemTakeDraft: {
        unitItemId: '',
        amountToTake: 0,
        unitItemIsProvisionedByOrder: false,
        takeFromOrderProvision: true,
        takeFromOrderProvisionData: {},
    },

    dialogOpen: false,

    status: APIRequestStatus.Idle,
    error: ''
}

const slice = createSlice({
    name: 'unitItemStockTake',
    initialState,
    reducers: {
        updateVal(state, action) {
          state.unitItemTakeDraft = action.payload;
          console.log(`State values: ${JSON.stringify(state.unitItemTakeDraft)}`);
        },
        updateDialogOpen(state, action) {
          state.dialogOpen = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postUnitItemStockTake.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postUnitItemStockTake.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postUnitItemStockTake.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
      }
})

export const postUnitItemStockTake = createAsyncThunk('unitItemStockTake/postUnitItemStockTake', async (arg, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/unititem/take',
      data: state.unitItemStockTake.unitItemTakeDraft,
    });

    // Backend COGS guard (unitItemStockAdd/TakePost): stock is NOT changed when the SKU's cost is
    // still unresolved (product inserted moments ago) — otherwise counters would move with no GL entry.
    if (response.data?.rejected === "COGS_BELUM_RESOLVE") {
      window.alert(response.data?.message
      // The backend explains why (midstock unused / product cost 0) once deployed.
      ? "DITOLAK: " + response.data.message + " (Stok TIDAK diubah.)"
      : "DITOLAK: cogs " + (response.data?.unitItemId ?? "SKU ini") +
        " belum ter-resolve (produk baru?). Stok TIDAK diubah — isi cogs produk dulu, lalu coba lagi.");
    }

    thunkAPI.dispatch(fetchUnitItemsList());

    return response.data
})

export const { updateVal, updateDialogOpen } = slice.actions

export default slice.reducer